<template>
  <div class="home">
    <div class="home-banner swiper-container">
      <div class="swiper-wrapper">
        <img
          v-for="(item, index) in bannerList"
          :key="index"
          :src="item.image"
          @click="toDetail(item)"
          width="100%"
          class="swiper-slide"
          alt=""
        />
        <!-- <c-link
          v-for="(item, index) in bannerList"
          :key="index"
          class="swiper-slide"
          :style="{
            backgroundImage: 'url(' + item.image + ')'
          }"
        ></c-link> -->
      </div>
    </div>
    <div v-for="item in menuList" :key="item.id">
      <cotentMain :pageType="item.pageType" :menuId="item.id" />
    </div>
    <!-- 悬浮窗 -->
    <div class="slide-bars" v-if="numshows">
      <div
        class="item"
        v-for="item in flowMenuList"
        :key="item.id"
        @click="clickItem(item)"
      >
        <div class="inner" v-if="item.pageType === '模板10-浮窗显示建议信箱'">
          <div class="tit">建议信箱</div>
          <div class="tt">不方便电话？还可以直接留言哦~</div>
          <div class="phone">
            <div class="txt">投诉电话</div>
            <div class="num">{{ concatInfo.title }}</div>
          </div>
          <div class="info">
            <div class="info-item">
              <input
                v-model="form.name"
                class="ipt"
                placeholder="请输入姓名"
                type="text"
              />
            </div>
            <div class="info-item">
              <input
                v-model="form.phone"
                class="ipt"
                placeholder="请输入电话"
                type="text"
              />
            </div>
          </div>
          <div class="message">
            <input
              v-model="form.content"
              class="textarea"
              type="text"
              placeholder="请输入留言"
            />
          </div>
          <div class="btn" @click="submit">留言</div>
        </div>
        <div class="inner enroll" v-if="item.name === '报名通道'">
          <div class="tit">报名通道</div>
          <div class="info">
            <div class="info-item">
              <input
                v-model="enrollForm.name"
                class="ipt"
                placeholder="请输入姓名"
                type="text"
              />
            </div>
            <div class="info-item">
              <input
                v-model="enrollForm.phone"
                class="ipt"
                placeholder="请输入电话"
                type="text"
              />
            </div>
          </div>

          <div class="btn" @click="submitEnroll">报名</div>
        </div>
        <div>
          <img class="img" :src="item.icon" alt="" />
        </div>
        <div class="txt">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle";
import pageMain_mx from "../../mixins/pageMain_mx";
import cotentMain from "./components/cotentMain";
import { Message } from "element-ui";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      bannerList: [],
      form: {},
      enrollForm: {},
      domain: "",
      numshows: false,
      concatInfo: {},
      platform: "",
      menuList: []
    };
  },
  components: { cotentMain },
  async mounted() {
    // 浮窗菜单1
    const flowSubMenu = this.getMenuSubList("浮窗菜单");
    this.flowMenuList = flowSubMenu;
    const obj = flowSubMenu.find(item => {
      return item.pageType === "模板10-浮窗显示建议信箱";
    });
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 1,
      menuId: obj.id
    });
    this.concatInfo = data[0] || {};
    window.addEventListener("scroll", this.scrollHandle);
  },
  methods: {
    async init() {
      const domain = document.domain;
      this.domain = domain;
      console.log(domain);
      let platform = "公司官网";
      if (domain.indexOf("xueli") > -1) {
        platform = "学历官网";
      } else if (domain.indexOf("zikao") > -1) {
        platform = "自考官网";
      } else if (domain.indexOf("zhijiao") > -1) {
        platform = "职教官网";
      }
      this.platform = platform;
      this.$api.cms.web.siteBanner_listForClient
        .get({
          platform
        })
        .then(res => {
          this.bannerList = res.data;
          console.log(this.bannerList, "bannerList");
          this.$nextTick(() => {
            new Swiper(".home-banner", {
              autoplay: true
            });
          });
        });
      const menus = this.menu.list;
      const menuList = menus.find(item => {
        return item.name === "首页";
      })["subMenus"];
      this.menuList = menuList;
      this.UserSwiper2();
    },
    // 监听滚动
    scrollHandle() {
      let scrllTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrllTop > 650) {
        this.numshows = true;
      } else {
        this.numshows = false;
      }
    },

    UserSwiper2() {
      // var thumbsSwiper = new Swiper("#swiper4", {
      //   loop: false,
      //   slidesPerView: 4,
      //   spaceBetween: 20,
      //   watchSlidesVisibility: true, //防止不可点击
      // });
      new Swiper("#swiper", {
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
        // thumbs: {
        //   swiper: thumbsSwiper,
        //   slideThumbActiveClass: "my-slide-thumb-active",
        // },
      });
    },
    toTop() {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    toDetail(item) {
      this.toUrl(item.url);
    },
    clickItem(item) {
      if (item.pageType === "模板18-回到顶部") {
        this.toTop();
      } else if (item.pageType === "模板9-联系我们") {
        this.$router.push({
          path: "/concact_us",
          query: {
            id: item.id
          }
        });
      }
    },
    submit() {
      if (!this.form.name) return Message("请先输入姓名");
      if (!this.form.phone) return Message("请先输入手机号");
      if (!this.form.content) return Message("请先输入内容");

      this.$api.cms.web.siteMessage
        .post({ ...this.form, platform: this.platform })
        .then(() => {
          Message.success("提交成功");
          this.form = {};
        });
    },
    submitEnroll() {
      if (!this.enrollForm.name) return Message("请先输入姓名");
      if (!this.enrollForm.phone) return Message("请先输入手机号");
      this.$api.ums.promote.backgroundMessage_messageForClient
        .post({ ...this.enrollForm, address: this.domain })
        .then(() => {
          Message.success("提交成功，请耐心等待老师与您联系");
          this.enrollForm = {};
        });
    }
  }
};
</script>
<style lang="less">
.home-banner {
  // height: 100%;
  width: 100%;
  // height: 1080px;
  &.swiper-container {
    .swiper-wrapper {
      .swiper-slide {
        width: 100%;

        background-position: 50%;
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
  }
  .m-link-a {
    display: block;
    height: 100%;
  }
}
.home-menu {
  position: relative;
  z-index: 1;
  height: 100px;
  .box {
    display: flex;
    align-items: center;
    width: 1040px;
    height: 200px;
    background-color: #fff;
    box-shadow: 0 0 14px 0 rgba(182, 182, 182, 0.5);
    margin: 0 auto 0 auto;
    position: relative;
    top: -100px;
  }
  .item {
    flex-grow: 1;
    flex-shrink: 0;
    & + .item {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -50px;
        width: 1px;
        height: 100px;
        background-color: #d8d8d8;
      }
    }
    .m-link-a {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &:hover {
      .item-ico {
        background-color: #e1ebf6;
      }
    }
  }
  .item-ico {
    flex-shrink: 0;
    width: 90px;
    height: 90px;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #f7f7f7;
    border-radius: 50%;
    &.n1 {
      background-image: url("../../assets/img/ico_6.png");
    }
    &.n2 {
      background-image: url("../../assets/img/ico_7.png");
    }
    &.n3 {
      background-image: url("../../assets/img/ico_8.png");
    }
  }
  .item-cont {
    margin-left: 13px;
  }
  .item-cap {
    color: #282828;
    font-size: 24px;
  }
  .item-tit {
    color: #606060;
    margin-top: 12px;
    width: 112px;
  }
}
.slide-bars {
  position: fixed;
  right: 14px;
  bottom: 100px;
  z-index: 222;
  transition: all 2s;
  .item {
    position: relative;
    margin-bottom: 2px;
    padding-top: 12px;
    width: 64px;
    height: 64px;
    background: rgba(0, 0, 0, 0.6);
    text-align: center;
    cursor: pointer;
    .img {
      width: 24px;
      height: 24px;
    }
    .txt {
      font-size: 12px;
      font-weight: 400;
      color: #fff;
    }
    .inner {
      display: none;
      position: absolute;
      text-align: left;
      padding: 40px;
      bottom: 10px;
      right: 64px;
      width: 500px;
      height: 506px;
      box-sizing: border-box;
      background: #fff;
      box-shadow: 0px 2px 16px 0px rgba(168, 170, 184, 0.22);
      .tit {
        font-size: 24px;
        color: #000;
      }
      .tt {
        padding-top: 4px;
        font-size: 14px;
        color: #a8aab8;
      }
      .phone {
        margin-top: 20px;
        width: 420px;
        height: 60px;
        border: 2px solid #ff8012;
        box-sizing: border-box;
        display: flex;
        .txt {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 120px;
          background: #ff8012;
          box-sizing: border-box;
          font-size: 20px;
          font-weight: 500;
          color: #fff;
        }
        .num {
          padding-top: 5px;
          padding-left: 20px;
          font-size: 32px;
          font-weight: 500;
          color: #000;
        }
      }
      .info {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        .info-item {
          .ipt {
            padding: 10px;
            width: 200px;
            height: 44px;
            box-sizing: border-box;
            background: #f2f4f9;
            border: none;
          }
        }
      }
      .message {
        margin-top: 20px;
        .textarea {
          padding: 12px 20px;
          width: 420px;
          height: 100px;
          box-sizing: border-box;
          border: none;
          background: #f2f4f9;
        }
      }
      .btn {
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 420px;
        height: 44px;
        background: #ff8012;
        border-radius: 2px;
        font-size: 14px;
        color: #fff;
      }
    }
    .inner.enroll {
      height: 300px;
    }
  }
  .item:hover {
    background: #1465f5;
    .inner {
      display: block;
    }
  }
}
</style>
